import { useState } from "react"

const useReportControls = () => {
  const [showReport, setShowReport] = useState<boolean>(false)
  const [showTHzHeatmap, setShowTHzHeatmap] = useState<boolean>(true)
  const [showTHzGraphs, setShowTHzGraphs] = useState<boolean>(true)
  // const [showMetalHeatmap, setShowMetalHeatmap] = useState<boolean>(false)
  // const [showMetalGraph, setShowMetalGraph] = useState<boolean>(false)
  // const [showThermalHeatmap, setShowThermalHeatmap] = useState<boolean>(false)
  // const [showThermalGraph, setShowThermalGraph] = useState<boolean>(false)
  const [showScanImages, setShowScanImages] = useState<boolean>(true)

  return [{
    showReport,
    showTHzHeatmapCheckbox: { value: showTHzHeatmap, onChange: () => setShowTHzHeatmap(!showTHzHeatmap) },
    showTHzGraphsCheckbox: { value: showTHzGraphs, onChange: () => setShowTHzGraphs(!showTHzGraphs) },
    showScanImagesCheckbox: { value: showScanImages, onChange: () => setShowScanImages(!showScanImages) },
    onShowReport: () => setShowReport(true),
    onHideReport: () => setShowReport(false)
  }]

}

export default useReportControls